import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "dropdown" };
const _hoisted_2 = {
    class: "dropdown__content",
    style: { "display": "none" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title !== null)
            ? (_openBlock(), _createElementBlock("h4", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = e => _ctx.$emit('toggle', e)),
                class: "dropdown__title"
            }, _toDisplayString(_ctx.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("a", {
                class: "btn dropdown__apply",
                onClick: _cache[1] || (_cache[1] = e => _ctx.$emit('apply', e))
            }, _toDisplayString(_ctx.$t('apply')), 1 /* TEXT */)
        ])
    ]));
}
